import { render, staticRenderFns } from "./UpcomingRelations.vue?vue&type=template&id=1e957988&"
import script from "./UpcomingRelations.vue?vue&type=script&lang=js&"
export * from "./UpcomingRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports